export default __webpack_public_path__ + "static/media/dp1.11757ea2.jpeg";